import React from "react";

// Import SVG files correctly
const countries = [
  { src: require("../assets/in.svg").default, alt: "India" },
  { src: require("../assets/ca.svg").default, alt: "Canada" },
  { src: require("../assets/us.svg").default, alt: "USA" },
  { src: require("../assets/sg.svg").default, alt: "Singapore" },
  { src: require("../assets/gb.svg").default, alt: "United Kingdom" },
  { src: require("../assets/au.svg").default, alt: "Australia" },
  { src: require("../assets/ae.svg").default, alt: "UAE" },

  { src: require("../assets/countries/be.svg").default, alt: "Belgium" },
  // New countries (path: ./assets/countries/)
  { src: require("../assets/countries/cn.svg").default, alt: "China" },
  { src: require("../assets/countries/de.svg").default, alt: "Germany" },
  { src: require("../assets/countries/jp.svg").default, alt: "Japan" },
  { src: require("../assets/countries/nl.svg").default, alt: "Netherlands" },
  { src: require("../assets/countries/kr.svg").default, alt: "South Korea" },
  { src: require("../assets/countries/fr.svg").default, alt: "France" },
  { src: require("../assets/countries/it.svg").default, alt: "Italy" },
  { src: require("../assets/countries/es.svg").default, alt: "Spain" },
  { src: require("../assets/countries/tw.svg").default, alt: "Taiwan" },
  { src: require("../assets/countries/my.svg").default, alt: "Malaysia" },
  { src: require("../assets/countries/vn.svg").default, alt: "Vietnam" },
  { src: require("../assets/countries/id.svg").default, alt: "Indonesia" },
  { src: require("../assets/countries/tr.svg").default, alt: "Turkey" },
  { src: require("../assets/countries/za.svg").default, alt: "South Africa" },
  { src: require("../assets/countries/ph.svg").default, alt: "Philippines" },
  { src: require("../assets/countries/ke.svg").default, alt: "Kenya" },
];



const MarqueeFlags = () => {
  return (
    <div className="bg-[#FFFFFF] py-10 text-center">
      <h2 className="text-3xl md:text-4xl font-extrabold text-[#4b2e19] text-center mb-10 drop-shadow-sm">
        Our Targeted Countries
      </h2>
      <p className="text-gray-700 max-w-4xl mx-auto text-base md:text-lg leading-relaxed mb-10">
        We proudly export premium organic fertilizers, coir products, natural
        powders, and bagasse tableware. If you're an importer, wholesaler,
        distributor, supplier, or a conscious buyer anywhere in the world —
        let's connect!
      </p>

      <div className="relative overflow-hidden w-full py-8 bg-gradient-to-r from-gray-50 via-gray-100 to-gray-50 rounded-lg shadow-inner">
        <div className="flex w-max items-center gap-12 flag-marquee">
          {/* Repeat countries twice for infinite scroll effect */}
          {[...Array(2)].map((_, i) => (
            <React.Fragment key={i}>
              {countries.map((country, index) => (
                <img
                  key={`${i}-${index}`}
                  src={country.src}
                  alt={country.alt}
                  className="h-16 w-auto object-contain flex-shrink-0 drop-shadow-sm"
                />
              ))}
            </React.Fragment>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes marqueeScroll {
          0% {
            transform: translateX(0%);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .flag-marquee {
          animation: marqueeScroll 15s linear infinite;
        }

        .flag-marquee:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
};

export default MarqueeFlags;